import { EmploymentOccupation } from "../../lead-api";
import type { OccupationMenuItem } from "../Employment.types";

export const employmentMenuItemsCO: OccupationMenuItem[] = [
  {
    label: "inputs.employment.self_employed",
    value: EmploymentOccupation.SelfEmployed,
  },
  {
    label: "inputs.employment.employed",
    value: EmploymentOccupation.Employed,
  },
  {
    label: "inputs.employment.business_owner",
    value: EmploymentOccupation.BusinessOwner,
  },
  {
    label: "inputs.employment.freelancer",
    value: EmploymentOccupation.Freelancer,
  },
  {
    label: "inputs.employment.not_employed",
    value: EmploymentOccupation.Unemployed,
  },
  {
    label: "inputs.employment.retired",
    value: EmploymentOccupation.Retired,
  },
  {
    label: "inputs.employment.student",
    value: EmploymentOccupation.Student,
  },
];
